module.exports = __webpack_public_path__ + "img/img_02.feb8ba23.jpg";